<ol class="list-group bg-dark">
  <li class="list-group-item bg-dark">
    <a [routerLink]="['/new-list']" class="btn btn-primary">Nieuwe lijst</a>
  </li>
  @for (list of lists | async; track list) {
    <li class="list-group-item bg-dark"
      >
      <a [routerLink]="['/lists', list.id]">{{list.name}}</a>
    </li>
  }
</ol>
